module.exports = __webpack_public_path__ + "media/phase3.2cfe7125.webm";